var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 180,
    viewBox: "-6 -2 334 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 11.25,
    d: "M186.724 125.05v40.61c0 6.19 3.471 11.855 8.996 14.664a16.541 16.541 0 007.48 1.8c3.417 0 6.822-1.064 9.678-3.15l101.323-73.539A16.47 16.47 0 00321 92.121c0-5.279-2.526-10.23-6.8-13.324L212.879 5.257a16.54 16.54 0 00-17.158-1.35 16.474 16.474 0 00-8.996 14.675v40.611H23.547C.794 59.193 0 77.323 0 91.874c0 13.561.794 33.175 23.547 33.175z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.f394e0ef.svg";
export { ForwardRef as ReactComponent };